var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"id":"bypass-main","href":"#main-content"}},[_vm._v("Skip to main content")]),_c('Header',{staticClass:"head"}),_c('main',{attrs:{"id":"main-content"}},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }